import FilterCollectionProvider from '@paperstac/common/lib/components/FilterCollectionProvider';
import SortCollectionProvider from '@paperstac/common/lib/components/SortCollectionProvider';
import React from 'react';
import RequireCurrentAccount from '../../common/RequireCurrentAccount';
import DefaultLayout from '../../layouts/DefaultLayout';
import Content from './Content';
import MyListingsPageProvider, { LISTING_SORTS } from './MyListingsPageProvider';

const [sortBy, sortDirection, sortLabel] = Object.values(LISTING_SORTS)[0];

const MyListingsPage = React.memo((props) => (
  <RequireCurrentAccount>
    <FilterCollectionProvider>
      <SortCollectionProvider sortBy={sortBy} sortDirection={sortDirection} sortLabel={sortLabel}>
        <MyListingsPageProvider>
          <DefaultLayout title="My Listings | Paperstac">
            <Content />
          </DefaultLayout>
        </MyListingsPageProvider>
      </SortCollectionProvider>
    </FilterCollectionProvider>
  </RequireCurrentAccount>
));

MyListingsPage.propTypes = {};

MyListingsPage.defaultProps = {};

MyListingsPage.displayName = 'MyListingsPage';

export default MyListingsPage;
